
// // import React, { useEffect, useState, useCallback } from 'react';
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Dialog,
// //   DialogActions,
// //   DialogContent,
// //   DialogTitle,
// //   TextField,
// //   LinearProgress,
// //   MenuItem,
// //   Chip,
// //   FormControl,
// //   InputLabel,
// //   Select,
// //   IconButton,
// //   Tooltip,
// //   Avatar,
// //   List,
// //   ListItem,
// //   ListItemAvatar,
// //   ListItemText,
// //   CircularProgress,
// // } from '@mui/material';
// // import {
// //   Clear as ClearIcon,
// //   ContentPaste as ContentPasteIcon,
// //   ManageAccounts as ManageAccountsIcon,
// //   Visibility as VisibilityIcon,
// // } from '@mui/icons-material';
// // import PeopleIcon from '@mui/icons-material/People';
// // import api from '../../../api/axiosInterceptor';
// // import TableComponent from '../../../Components/TableComponent/TableComponent';
// // import { LoadingSpinner } from '../../../Components/spinner/spinner';
// // import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// // import { BulkPermissionDialog } from './adminEpmsPermission';
// // import { AdminExcessRangeDeleteDialog } from './adminEpmsBulkDelete';


// // const sampleHeaders = [
// //   "reference_id", "name", "address", "contact_number",
// //   "nominee_name", "nominee_address", "nominee_contact_number",
// //   "account_number", "ifsc_code", "catogary",
// //   "deposited_amount", "returned_amount", "excess_amount","pan_no",
// // ];


// // export const AdminExcessMasterComponent = () => {
// //   const [rows, setRows] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [feBaseList, setFeBaseList] = useState([]);
// //   const [selectedFeName, setSelectedFeName] = useState('');
// //   const [selectedFeId, setSelectedFeId] = useState('');


// //   // Range delete dialog
// //   const [rangeDeleteDialog, setRangeDeleteDialog] = useState(false);


// //   // Bulk permission dialog
// //   const [bulkPermissionDialog, setBulkPermissionDialog] = useState(false);


// //   // Permission view dialog (eye icon)
// //   const [permViewDialog, setPermViewDialog] = useState(false);
// //   const [permViewRecord, setPermViewRecord] = useState(null);
// //   const [permViewUsers, setPermViewUsers] = useState([]);
// //   const [permViewLoading, setPermViewLoading] = useState(false);


// //   // Upload
// //   const [openUploadDialog, setOpenUploadDialog] = useState(false);
// //   const [uploadingFile, setUploadingFile] = useState(false);
// //   const [uploadProgress, setUploadProgress] = useState(0);
// //   const [selectedFile, setSelectedFile] = useState(null);


// //   // Sample / Error dialogs
// //   const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);
// //   const [openErrorDialog, setOpenErrorDialog] = useState(false);
// //   const [fullErrorDetails, setFullErrorDetails] = useState('');
// //   const [errorRowCount, setErrorRowCount] = useState(0);


// //   // Snackbar
// //   const [snackbarOpen, setSnackbarOpen] = useState(false);
// //   const [snackbarMessage, setSnackbarMessage] = useState('');
// //   const [snackbarSeverity, setSnackbarSeverity] = useState('info');


// //   const showSuccess = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
// //   const showError   = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('error');   setSnackbarOpen(true); };
// //   const showWarning = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('warning'); setSnackbarOpen(true); };


// //   // ── Columns — with Permissions column at the end ─────────────────────────
// //   const columns = [
// //     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
// //     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
// //     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
// //     { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
// //     { id: 'address', field: 'address', headerName: 'Address', width: 200 },
// //     { id: 'contact_number', field: 'contact_number', headerName: 'Contact', width: 130 },
// //     { id: 'account_number', field: 'account_number', headerName: 'Account No', width: 150 },
// //     { id: 'ifsc_code', field: 'ifsc_code', headerName: 'IFSC Code', width: 120 },
// //     { id: 'catogary', field: 'catogary', headerName: 'Category', width: 120 },
// //     { id: 'deposited_amount', field: 'deposited_amount', headerName: 'Deposited', width: 130 },
// //     { id: 'returned_amount', field: 'returned_amount', headerName: 'Returned', width: 130 },
// //     { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130 },
// //     {
// //       id: 'permissions',
// //       field: 'permissions',
// //       headerName: 'Permissions',
// //       width: 120,
// //       renderCell: (params) => {
// //         return (
// //           <Box display="flex" alignItems="center" gap={0.5}>
// //             <Tooltip title="View allowed users">
// //               <IconButton size="small" onClick={() => handleViewPermissions(params.row)}>
// //                 <PeopleIcon  fontSize="small" color="action" />
// //               </IconButton>
// //             </Tooltip>
// //           </Box>
// //         );
// //       },
// //     },
// //   ];


// //   // ── Data fetching ─────────────────────────────────────────────────────────
// //   useEffect(() => { fetchFeBaseList(); }, []);


// //   const fetchFeBaseList = () => {
// //     api.get('/fe-mgmt/fe-base/')
// //       .then(res => setFeBaseList(res.data || []))
// //       .catch(() => setFeBaseList([]));
// //   };


// //   const fetchExcessRecords = useCallback((feName) => {
// //     if (!feName) { setRows([]); return; }
// //     setLoading(true);
// //     api.get(`/excess_payment_mgmt/excess-master-list/?fe_name=${encodeURIComponent(feName)}`)
// //       .then(res => {
// //         setRows(res.data.map((item, index) => ({
// //           id: item.id,
// //           slNo: index + 1,
// //           fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
// //           ...item,
// //         })));
// //       })
// //       .catch(() => showError('Failed to load excess records.'))
// //       .finally(() => setLoading(false));
// //   }, []);


// //   useEffect(() => { fetchExcessRecords(selectedFeName); }, [selectedFeName, fetchExcessRecords]);


// //   // ── Permission View (eye icon) ────────────────────────────────────────────
// //   const handleViewPermissions = (record) => {
// //     setPermViewRecord(record);
// //     setPermViewUsers([]);
// //     setPermViewDialog(true);
// //     setPermViewLoading(true);
// //     api.get(`/excess_payment_mgmt/excess/bulk-permission/?excess_id=${record.id}`)
// //       .then(res => setPermViewUsers(res.data?.users || []))
// //       .catch(() => setPermViewUsers(record.auth_user || []))
// //       .finally(() => setPermViewLoading(false));
// //   };


// //   // ── Upload ────────────────────────────────────────────────────────────────
// //   const handleFileChange = (e) => { if (e.target.files.length > 0) setSelectedFile(e.target.files[0]); };


// //   const handleUploadSubmit = async () => {
// //     if (!selectedFile) { showWarning('Please select a file.'); return; }
// //     if (!selectedFeId) { showWarning('Please select a Financial Establishment.'); return; }
// //     if (!['.xls', '.xlsx'].some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
// //       showWarning('Invalid format. Please upload .xls or .xlsx.');
// //       return;
// //     }
// //     const formData = new FormData();
// //     formData.append('excel_file', selectedFile);
// //     formData.append('fe_id', selectedFeId);
// //     try {
// //       setUploadingFile(true);
// //       await api.post('/excess_payment_mgmt/excess-record-uploader/', formData, {
// //         headers: { 'Content-Type': 'multipart/form-data' },
// //         onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
// //       });
// //       showSuccess('File uploaded successfully.');
// //       setOpenUploadDialog(false);
// //       const feObj = feBaseList.find(fe => fe.id === selectedFeId);
// //       setSelectedFeName(feObj?.name || feObj?.name_of_fe || '');
// //       setSelectedFile(null);
// //       setSelectedFeId('');
// //     } catch (error) {
// //       const err = error?.response?.data;
// //       if (err?.validation_errors && Array.isArray(err.validation_errors)) {
// //         setFullErrorDetails(
// //           err.validation_errors.map((e, i) => `Row ${i + 2}: ${e.error || e.message || JSON.stringify(e)}`).join('\n')
// //         );
// //         setErrorRowCount(err.validation_errors.length);
// //         setOpenErrorDialog(true);
// //         showError(`Validation failed: ${err.validation_errors.length} rows had errors.`);
// //       } else {
// //         showError(err?.error || err?.message || 'Failed to upload file.');
// //       }
// //     } finally {
// //       setUploadingFile(false);
// //       setUploadProgress(0);
// //     }
// //   };


// //   // ── Render ────────────────────────────────────────────────────────────────
// //   return (
// //     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>


// //       {/* ── Header bar ── */}
// //       <Box
// //         display="flex" justifyContent="space-between" alignItems="center"
// //         bgcolor="rgba(195,234,203,0.1)" p={2} flexWrap="wrap" gap={2}
// //       >
// //         {/* FE Selector */}
// //         <Box display="flex" gap={2} alignItems="center">
// //           <Typography variant="h6" fontWeight="bold">Select FE Base:</Typography>
// //           <FormControl size="small" sx={{ minWidth: 280 }}>
// //             <InputLabel>Select FE Base</InputLabel>
// //             <Select
// //               value={selectedFeName}
// //               label="Select FE Base"
// //               onChange={e => setSelectedFeName(e.target.value)}
// //             >
// //               <MenuItem value=""><em>Select FE to view records</em></MenuItem>
// //               {feBaseList.map(fe => (
// //                 <MenuItem key={fe.id} value={fe.name || fe.name_of_fe || fe.id}>
// //                   {fe.name || fe.name_of_fe || fe.id}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //         </Box>


// //         {/* Action buttons — visible when FE is selected */}
// //         {selectedFeName && (
// //           <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
// //             <Button
// //               variant="contained" color="secondary" size="small"
// //               startIcon={<ManageAccountsIcon />}
// //               onClick={() => setBulkPermissionDialog(true)}
// //               disabled={rows.length === 0}
// //             >
// //               Bulk Permission
// //             </Button>
// //             <Button
// //               variant="outlined" color="error" size="small"
// //               startIcon={<ClearIcon />}
// //               onClick={() => setRangeDeleteDialog(true)}
// //               disabled={rows.length === 0}
// //             >
// //               Range Delete
// //             </Button>
// //             <Button
// //               variant="outlined" color="primary" size="small"
// //               onClick={() => setOpenUploadDialog(true)}
// //             >
// //               Upload Excel
// //             </Button>
// //           </Box>
// //         )}
// //       </Box>


// //       {/* ── Table ── */}
// //       {loading ? (
// //         <LoadingSpinner size={30} />
// //       ) : selectedFeName && rows.length > 0 ? (
// //         <TableComponent
// //           columns={columns}
// //           rows={rows}
// //           manageColumnStatus
// //           enableSort
// //           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
// //         />
// //       ) : selectedFeName ? (
// //         <Box p={4} textAlign="center">
// //           <Typography>No records found for selected FE.</Typography>
// //         </Box>
// //       ) : null}


// //       {/* ════════════════════════════
// //           Dialogs
// //       ════════════════════════════ */}


// //       {/* ── Creating Record — upload in progress overlay ── */}
// //       <Dialog
// //         open={uploadingFile}
// //         disableEscapeKeyDown
// //         PaperProps={{
// //           sx: {
// //             borderRadius: 3,
// //             px: 4,
// //             py: 3,
// //             minWidth: 280,
// //             textAlign: 'center',
// //             boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
// //           },
// //         }}
// //       >
// //         <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pb: 1 }}>
// //           <CircularProgress size={52} thickness={4.5} />
// //           <Typography variant="h6" fontWeight="bold" mt={1}>
// //             Creating Records
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary">
// //             Please wait, don't refresh the page…
// //           </Typography>
// //           <Box sx={{ width: '100%', mt: 1 }}>
// //             <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: 2, height: 6 }} />
// //             <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
// //               {uploadProgress}%
// //             </Typography>
// //           </Box>
// //         </DialogContent>
// //       </Dialog>


// //       {/* Permission View (eye icon) */}
// //       <Dialog open={permViewDialog} onClose={() => setPermViewDialog(false)} maxWidth="xs" fullWidth>
// //         <DialogTitle>
// //           <Typography variant="h6" fontWeight="bold">Allowed Users</Typography>
// //           {permViewRecord && (
// //             <Typography variant="body2" color="text.secondary">
// //               {permViewRecord.reference_id} — {permViewRecord.name}
// //             </Typography>
// //           )}
// //         </DialogTitle>
// //         <DialogContent>
// //           {permViewLoading ? (
// //             <Box display="flex" justifyContent="center" py={3}>
// //               <LoadingSpinner size={24} />
// //             </Box>
// //           ) : permViewUsers.length === 0 ? (
// //             <Box py={2} textAlign="center">
// //               <Typography variant="body2" color="text.secondary">
// //                 No users have been granted permission for this record.
// //               </Typography>
// //             </Box>
// //           ) : (
// //             <List dense>
// //               {permViewUsers.map((user, idx) => (
// //                 <ListItem key={user.id || idx} divider={idx < permViewUsers.length - 1}>
// //                   <ListItemAvatar>
// //                     <Avatar sx={{ width: 32, height: 32, fontSize: 13, bgcolor: 'primary.main' }}>
// //                       {(user.name || user.username || '?')[0].toUpperCase()}
// //                     </Avatar>
// //                   </ListItemAvatar>
// //                   <ListItemText
// //                     primary={user.name || user.username || '—'}
// //                     secondary={user.email || '—'}
// //                     primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
// //                     secondaryTypographyProps={{ variant: 'caption' }}
// //                   />
// //                 </ListItem>
// //               ))}
// //             </List>
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setPermViewDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>


// //       {/* Range Delete — using separate component */}
// //       <AdminExcessRangeDeleteDialog
// //         open={rangeDeleteDialog}
// //         onClose={() => setRangeDeleteDialog(false)}
// //         feName={selectedFeName}
// //         feId={selectedFeId}
// //         rows={rows}
// //         onSuccess={showSuccess}
// //         onError={showError}
// //         onDone={() => fetchExcessRecords(selectedFeName)}
// //       />


// //       {/* Bulk Permission */}
// //       <BulkPermissionDialog
// //         open={bulkPermissionDialog}
// //         onClose={() => {
// //           setBulkPermissionDialog(false);
// //           fetchExcessRecords(selectedFeName); // refresh to update permission counts
// //         }}
// //         rows={rows}
// //         onSuccess={showSuccess}
// //         onError={showError}
// //       />


// //       {/* Upload Excel */}
// //       <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
// //         <DialogTitle>Upload Excess Amount Excel File</DialogTitle>
// //         <DialogContent>
// //           <Box display="flex" gap={1} alignItems="center" mb={2} mt={1}>
// //             <TextField select fullWidth size="small" label="Financial Establishment (FE Base)"
// //               value={selectedFeId} onChange={e => setSelectedFeId(e.target.value)} disabled={uploadingFile}>
// //               {feBaseList.map(fe => (
// //                 <MenuItem key={fe.id} value={fe.id}>{fe.name || fe.name_of_fe || fe.id}</MenuItem>
// //               ))}
// //             </TextField>
// //             <Tooltip title="View Sample Format">
// //               <IconButton size="small" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
// //                 <ContentPasteIcon />
// //               </IconButton>
// //             </Tooltip>
// //           </Box>
// //           <Button variant="outlined" component="label" fullWidth>
// //             {selectedFile ? selectedFile.name : 'Select Excel File (.xls, .xlsx)'}
// //             <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
// //           </Button>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
// //           <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile || !selectedFeId || !selectedFile}>
// //             Upload
// //           </Button>
// //         </DialogActions>
// //       </Dialog>


// //       {/* Sample Format */}
// //       <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
// //         <DialogTitle>Excel Column Headers (Exact Match Required)</DialogTitle>
// //         <DialogContent dividers>
// //           <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '14px' }}>
// //             {sampleHeaders.join('\n')}
// //           </Typography>
// //           <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
// //             * Required: reference_id, name, account_number, ifsc_code, deposited_amount, returned_amount, excess_amount
// //           </Typography>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>


// //       {/* Validation Errors */}
// //       <Dialog
// //         open={openErrorDialog}
// //         onClose={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
// //         maxWidth="md" fullWidth
// //       >
// //         <DialogTitle>Validation Errors ({errorRowCount} rows failed)</DialogTitle>
// //         <DialogContent sx={{ maxHeight: 400, overflow: 'auto' }}>
// //           <Typography component="pre" sx={{
// //             whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px',
// //             backgroundColor: '#f5f5f5', p: 2, borderRadius: 1,
// //           }}>
// //             {fullErrorDetails}
// //           </Typography>
// //         </DialogContent>
// //         <DialogActions>
// //           <Button
// //             onClick={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
// //             variant="contained" color="primary"
// //           >
// //             Close
// //           </Button>
// //         </DialogActions>
// //       </Dialog>


// //       <SnackBarComponent
// //         open={snackbarOpen}
// //         message={snackbarMessage}
// //         severity={snackbarSeverity}
// //         onClose={() => setSnackbarOpen(false)}
// //       />
// //     </Box>
// //   );
// // };


// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   LinearProgress,
//   MenuItem,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   IconButton,
//   Tooltip,
//   Avatar,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Clear as ClearIcon,
//   ContentPaste as ContentPasteIcon,
//   ManageAccounts as ManageAccountsIcon,
//   Visibility as VisibilityIcon,
// } from '@mui/icons-material';
// import PeopleIcon from '@mui/icons-material/People';
// import api from '../../../api/axiosInterceptor';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { BulkPermissionDialog } from './adminEpmsPermission';
// import { AdminExcessRangeDeleteDialog } from './adminEpmsBulkDelete';


// const sampleHeaders = [
//   "reference_id", "name", "address", "contact_number",
//   "nominee_name", "nominee_address", "nominee_contact_number",
//   "account_number", "ifsc_code", "catogary",
//   "deposited_amount", "returned_amount", "excess_amount","pan_no",
// ];


// export const AdminExcessMasterComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [feBaseList, setFeBaseList] = useState([]);
//   const [selectedFeName, setSelectedFeName] = useState('');
//   const [selectedFeId, setSelectedFeId] = useState('');


//   // Range delete dialog
//   const [rangeDeleteDialog, setRangeDeleteDialog] = useState(false);


//   // Bulk permission dialog
//   const [bulkPermissionDialog, setBulkPermissionDialog] = useState(false);


//   // Permission view dialog (eye icon)
//   const [permViewDialog, setPermViewDialog] = useState(false);
//   const [permViewRecord, setPermViewRecord] = useState(null);
//   const [permViewUsers, setPermViewUsers] = useState([]);
//   const [permViewLoading, setPermViewLoading] = useState(false);


//   // Upload
//   const [openUploadDialog, setOpenUploadDialog] = useState(false);
//   const [uploadingFile, setUploadingFile] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [selectedFile, setSelectedFile] = useState(null);


//   // Sample / Error dialogs
//   const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);
//   const [openErrorDialog, setOpenErrorDialog] = useState(false);
//   const [fullErrorDetails, setFullErrorDetails] = useState('');
//   const [errorRowCount, setErrorRowCount] = useState(0);


//   // Snackbar
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');


//   const showSuccess = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
//   const showError   = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('error');   setSnackbarOpen(true); };
//   const showWarning = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('warning'); setSnackbarOpen(true); };


//   // ── Columns — with Permissions column at the end ─────────────────────────
//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
//     { id: 'address', field: 'address', headerName: 'Address', width: 200 },
//     { id: 'contact_number', field: 'contact_number', headerName: 'Contact', width: 130 },
//     { id: 'account_number', field: 'account_number', headerName: 'Account No', width: 150 },
//     { id: 'ifsc_code', field: 'ifsc_code', headerName: 'IFSC Code', width: 120 },
//     { id: 'catogary', field: 'catogary', headerName: 'Category', width: 120 },
//     { id: 'deposited_amount', field: 'deposited_amount', headerName: 'Deposited', width: 130 },
//     { id: 'returned_amount', field: 'returned_amount', headerName: 'Returned', width: 130 },
//     { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130 },
//     {
//       id: 'permissions',
//       field: 'permissions',
//       headerName: 'Permissions',
//       width: 120,
//       renderCell: (params) => {
//         return (
//           <Box display="flex" alignItems="center" gap={0.5}>
//             <Tooltip title="View allowed users">
//               <IconButton size="small" onClick={() => handleViewPermissions(params.row)}>
//                 <PeopleIcon  fontSize="small" color="action" />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );
//       },
//     },
//   ];


//   // ── Data fetching ─────────────────────────────────────────────────────────
//   useEffect(() => { fetchFeBaseList(); }, []);


//   const fetchFeBaseList = () => {
//     api.get('/fe-mgmt/fe-base/')
//       .then(res => setFeBaseList(res.data || []))
//       .catch(() => setFeBaseList([]));
//   };


//   const fetchExcessRecords = useCallback((feName) => {
//     if (!feName) { setRows([]); return; }
//     setLoading(true);
//     api.get(`/excess_payment_mgmt/excess-master-list/?fe_name=${encodeURIComponent(feName)}`)
//       .then(res => {
//         setRows(res.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
//           ...item,
//         })));
//       })
//       .catch(() => showError('Failed to load excess records.'))
//       .finally(() => setLoading(false));
//   }, []);


//   useEffect(() => { fetchExcessRecords(selectedFeName); }, [selectedFeName, fetchExcessRecords]);


//   // ── Permission View (eye icon) ────────────────────────────────────────────
//   const handleViewPermissions = (record) => {
//     setPermViewRecord(record);
//     setPermViewUsers([]);
//     setPermViewDialog(true);
//     setPermViewLoading(true);
//     api.get(`/excess_payment_mgmt/excess/bulk-permission/?excess_id=${record.id}`)
//       .then(res => setPermViewUsers(res.data?.users || []))
//       .catch(() => setPermViewUsers(record.auth_user || []))
//       .finally(() => setPermViewLoading(false));
//   };


//   // ── Upload ────────────────────────────────────────────────────────────────
//   const handleFileChange = (e) => { if (e.target.files.length > 0) setSelectedFile(e.target.files[0]); };


//   const handleUploadSubmit = async () => {
//     if (!selectedFile) { showWarning('Please select a file.'); return; }
//     if (!selectedFeId) { showWarning('Please select a Financial Establishment.'); return; }
//     if (!['.xls', '.xlsx'].some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
//       showWarning('Invalid format. Please upload .xls or .xlsx.');
//       return;
//     }
//     const formData = new FormData();
//     formData.append('excel_file', selectedFile);
//     formData.append('fe_id', selectedFeId);
//     try {
//       setUploadingFile(true);
//       await api.post('/excess_payment_mgmt/excess-record-uploader/', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//       });
//       showSuccess('File uploaded successfully.');
//       setOpenUploadDialog(false);
//       const feObj = feBaseList.find(fe => fe.id === selectedFeId);
//       setSelectedFeName(feObj?.name || feObj?.name_of_fe || '');
//       setSelectedFile(null);
//       setSelectedFeId('');
//     } catch (error) {
//       const err = error?.response?.data;
//       if (err?.validation_errors && Array.isArray(err.validation_errors)) {
//         setFullErrorDetails(
//           err.validation_errors.map((e, i) => `Row ${i + 2}: ${e.error || e.message || JSON.stringify(e)}`).join('\n')
//         );
//         setErrorRowCount(err.validation_errors.length);
//         setOpenErrorDialog(true);
//         showError(`Validation failed: ${err.validation_errors.length} rows had errors.`);
//       } else {
//         showError(err?.error || err?.message || 'Failed to upload file.');
//       }
//     } finally {
//       setUploadingFile(false);
//       setUploadProgress(0);
//     }
//   };


//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>


//       {/* ── Header bar ── */}
//       <Box
//         display="flex" justifyContent="space-between" alignItems="center"
//         bgcolor="rgba(195,234,203,0.1)" p={2} flexWrap="wrap" gap={2}
//       >
//         {/* FE Selector */}
//         <Box display="flex" gap={2} alignItems="center">
//           <Typography variant="h6" fontWeight="bold">Select FE Base:</Typography>
//           <FormControl size="small" sx={{ minWidth: 280 }}>
//             <InputLabel>Select FE Base</InputLabel>
//             <Select
//               value={selectedFeName}
//               label="Select FE Base"
//               onChange={e => setSelectedFeName(e.target.value)}
//             >
//               <MenuItem value=""><em>Select FE to view records</em></MenuItem>
//               {feBaseList.map(fe => (
//                 <MenuItem key={fe.id} value={fe.name || fe.name_of_fe || fe.id}>
//                   {fe.name || fe.name_of_fe || fe.id}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Box>


//         {/* Action buttons — visible when FE is selected */}
//         {selectedFeName && (
//           <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
//             <Button
//               variant="contained" color="secondary" size="small"
//               startIcon={<ManageAccountsIcon />}
//               onClick={() => setBulkPermissionDialog(true)}
//               disabled={rows.length === 0}
//             >
//               Bulk Permission
//             </Button>
//             <Button
//               variant="outlined" color="error" size="small"
//               startIcon={<ClearIcon />}
//               onClick={() => setRangeDeleteDialog(true)}
//               disabled={rows.length === 0}
//             >
//               Range Delete
//             </Button>
//             <Button
//               variant="outlined" color="primary" size="small"
//               onClick={() => setOpenUploadDialog(true)}
//             >
//               Upload Excel
//             </Button>
//           </Box>
//         )}
//       </Box>


//       {/* ── Table ── */}
//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : selectedFeName && rows.length > 0 ? (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//         />
//       ) : selectedFeName ? (
//         <Box p={4} textAlign="center">
//           <Typography>No records found for selected FE.</Typography>
//         </Box>
//       ) : null}


//       {/* ════════════════════════════
//           Dialogs
//       ════════════════════════════ */}


//       {/* ── Creating Record — upload in progress overlay ── */}
//       <Dialog
//         open={uploadingFile}
//         disableEscapeKeyDown
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             px: 4,
//             py: 3,
//             minWidth: 280,
//             textAlign: 'center',
//             boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
//           },
//         }}
//       >
//         <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pb: 1 }}>
//           <CircularProgress size={52} thickness={4.5} />
//           <Typography variant="h6" fontWeight="bold" mt={1}>
//             Creating Records
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Please wait, don't refresh the page…
//           </Typography>
//           <Box sx={{ width: '100%', mt: 1 }}>
//             <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: 2, height: 6 }} />
//             <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
//               {uploadProgress}%
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>


//       {/* Permission View (eye icon) — shows User, SHR, and Forensic Auditor labeled */}
//       <Dialog open={permViewDialog} onClose={() => setPermViewDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h6" fontWeight="bold">Allowed Users</Typography>
//           {permViewRecord && (
//             <Typography variant="body2" color="text.secondary">
//               {permViewRecord.reference_id} — {permViewRecord.name}
//             </Typography>
//           )}
//         </DialogTitle>
//         <DialogContent>
//           {permViewLoading ? (
//             <Box display="flex" justifyContent="center" py={3}>
//               <LoadingSpinner size={24} />
//             </Box>
//           ) : permViewUsers.length === 0 ? (
//             <Box py={2} textAlign="center">
//               <Typography variant="body2" color="text.secondary">
//                 No users have been granted permission for this record.
//               </Typography>
//             </Box>
//           ) : (
//             <List dense>
//               {permViewUsers.map((entry, idx) => (
//                 <ListItem
//                   key={entry.id || idx}
//                   divider={idx < permViewUsers.length - 1}
//                   sx={{ alignItems: 'flex-start', py: 1.5 }}
//                 >
//                   <Box display="flex" flexDirection="column" gap={1} width="100%">
//                     {/* Normal User */}
//                     <Box display="flex" alignItems="center" gap={1.5}>
//                       <Avatar sx={{ width: 32, height: 32, fontSize: 13, bgcolor: 'primary.main' }}>
//                         {(entry.name || entry.username || '?')[0].toUpperCase()}
//                       </Avatar>
//                       <Box>
//                         <Typography variant="caption" color="text.secondary" display="block" fontWeight={600}>
//                           USER
//                         </Typography>
//                         <Typography variant="body2" fontWeight={600}>
//                           {entry.name || '—'}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {entry.email || '—'}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     {/* SHR Name */}
//                     <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
//                       <Chip
//                         label="SHR"
//                         size="small"
//                         color="secondary"
//                         variant="outlined"
//                         sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
//                       />
//                       <Typography variant="body2">
//                         {entry.shr_name || '—'}
//                       </Typography>
//                     </Box>

//                     {/* Forensic Auditor */}
//                     <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
//                       <Chip
//                         label="FORENSIC AUDITOR"
//                         size="small"
//                         color="warning"
//                         variant="outlined"
//                         sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
//                       />
//                       <Box>
//                         <Typography variant="body2">
//                           {entry.forensic_auditor_name || '—'}
//                         </Typography>
//                         {entry.forensic_auditor_email && (
//                           <Typography variant="caption" color="text.secondary">
//                             {entry.forensic_auditor_email}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>

//                     {entry.authorized_date && (
//                       <Typography variant="caption" color="text.disabled" pl={0.5}>
//                         Authorized on {new Date(entry.authorized_date).toLocaleString()}
//                       </Typography>
//                     )}
//                   </Box>
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setPermViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>


//       {/* Range Delete — using separate component */}
//       <AdminExcessRangeDeleteDialog
//         open={rangeDeleteDialog}
//         onClose={() => setRangeDeleteDialog(false)}
//         feName={selectedFeName}
//         feId={selectedFeId}
//         rows={rows}
//         onSuccess={showSuccess}
//         onError={showError}
//         onDone={() => fetchExcessRecords(selectedFeName)}
//       />


//       {/* Bulk Permission */}
//       <BulkPermissionDialog
//         open={bulkPermissionDialog}
//         onClose={() => {
//           setBulkPermissionDialog(false);
//           fetchExcessRecords(selectedFeName); // refresh to update permission counts
//         }}
//         rows={rows}
//         onSuccess={showSuccess}
//         onError={showError}
//       />


//       {/* Upload Excel */}
//       <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Upload Excess Amount Excel File</DialogTitle>
//         <DialogContent>
//           <Box display="flex" gap={1} alignItems="center" mb={2} mt={1}>
//             <TextField select fullWidth size="small" label="Financial Establishment (FE Base)"
//               value={selectedFeId} onChange={e => setSelectedFeId(e.target.value)} disabled={uploadingFile}>
//               {feBaseList.map(fe => (
//                 <MenuItem key={fe.id} value={fe.id}>{fe.name || fe.name_of_fe || fe.id}</MenuItem>
//               ))}
//             </TextField>
//             <Tooltip title="View Sample Format">
//               <IconButton size="small" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
//                 <ContentPasteIcon />
//               </IconButton>
//             </Tooltip>
//           </Box>
//           <Button variant="outlined" component="label" fullWidth>
//             {selectedFile ? selectedFile.name : 'Select Excel File (.xls, .xlsx)'}
//             <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
//           </Button>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
//           <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile || !selectedFeId || !selectedFile}>
//             Upload
//           </Button>
//         </DialogActions>
//       </Dialog>


//       {/* Sample Format */}
//       <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Excel Column Headers (Exact Match Required)</DialogTitle>
//         <DialogContent dividers>
//           <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '14px' }}>
//             {sampleHeaders.join('\n')}
//           </Typography>
//           <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
//             * Required: reference_id, name, account_number, ifsc_code, deposited_amount, returned_amount, excess_amount
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>


//       {/* Validation Errors */}
//       <Dialog
//         open={openErrorDialog}
//         onClose={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
//         maxWidth="md" fullWidth
//       >
//         <DialogTitle>Validation Errors ({errorRowCount} rows failed)</DialogTitle>
//         <DialogContent sx={{ maxHeight: 400, overflow: 'auto' }}>
//           <Typography component="pre" sx={{
//             whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px',
//             backgroundColor: '#f5f5f5', p: 2, borderRadius: 1,
//           }}>
//             {fullErrorDetails}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
//             variant="contained" color="primary"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>


//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };


// import React, { useEffect, useState, useCallback } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   LinearProgress,
//   MenuItem,
//   Chip,
//   Autocomplete,
//   IconButton,
//   Tooltip,
//   Avatar,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Clear as ClearIcon,
//   ContentPaste as ContentPasteIcon,
//   ManageAccounts as ManageAccountsIcon,
//   Visibility as VisibilityIcon,
// } from '@mui/icons-material';
// import PeopleIcon from '@mui/icons-material/People';
// import api from '../../../api/axiosInterceptor';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { BulkPermissionDialog } from './adminEpmsPermission';
// import { AdminExcessRangeDeleteDialog } from './adminEpmsBulkDelete';


// const sampleHeaders = [
//   "reference_id", "name", "address", "contact_number",
//   "nominee_name", "nominee_address", "nominee_contact_number",
//   "account_number", "ifsc_code", "catogary",
//   "deposited_amount", "returned_amount", "excess_amount","pan_no",
// ];


// export const AdminExcessMasterComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [feBaseList, setFeBaseList] = useState([]);
//   const [selectedFeName, setSelectedFeName] = useState('');
//   const [selectedFeId, setSelectedFeId] = useState('');


//   // Range delete dialog
//   const [rangeDeleteDialog, setRangeDeleteDialog] = useState(false);


//   // Bulk permission dialog
//   const [bulkPermissionDialog, setBulkPermissionDialog] = useState(false);


//   // Permission view dialog (eye icon)
//   const [permViewDialog, setPermViewDialog] = useState(false);
//   const [permViewRecord, setPermViewRecord] = useState(null);
//   const [permViewUsers, setPermViewUsers] = useState([]);
//   const [permViewLoading, setPermViewLoading] = useState(false);


//   // Upload
//   const [openUploadDialog, setOpenUploadDialog] = useState(false);
//   const [uploadingFile, setUploadingFile] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [selectedFile, setSelectedFile] = useState(null);


//   // Sample / Error dialogs
//   const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);
//   const [openErrorDialog, setOpenErrorDialog] = useState(false);
//   const [fullErrorDetails, setFullErrorDetails] = useState('');
//   const [errorRowCount, setErrorRowCount] = useState(0);


//   // Snackbar
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');


//   const showSuccess = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
//   const showError   = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('error');   setSnackbarOpen(true); };
//   const showWarning = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('warning'); setSnackbarOpen(true); };


//   // ── Columns — with Permissions column at the end ─────────────────────────
//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
//     { id: 'address', field: 'address', headerName: 'Address', width: 200 },
//     { id: 'contact_number', field: 'contact_number', headerName: 'Contact', width: 130 },
//     { id: 'account_number', field: 'account_number', headerName: 'Account No', width: 150 },
//     { id: 'ifsc_code', field: 'ifsc_code', headerName: 'IFSC Code', width: 120 },
//     { id: 'catogary', field: 'catogary', headerName: 'Category', width: 120 },
//     { id: 'deposited_amount', field: 'deposited_amount', headerName: 'Deposited', width: 130 },
//     { id: 'returned_amount', field: 'returned_amount', headerName: 'Returned', width: 130 },
//     { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130 },
//     {
//       id: 'permissions',
//       field: 'permissions',
//       headerName: 'Permissions',
//       width: 120,
//       renderCell: (params) => {
//         return (
//           <Box display="flex" alignItems="center" gap={0.5}>
//             <Tooltip title="View allowed users">
//               <IconButton size="small" onClick={() => handleViewPermissions(params.row)}>
//                 <PeopleIcon  fontSize="small" color="action" />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         );
//       },
//     },
//   ];


//   // ── Data fetching ─────────────────────────────────────────────────────────
//   useEffect(() => { fetchFeBaseList(); }, []);


//   const fetchFeBaseList = () => {
//     api.get('/fe-mgmt/fe-base/')
//       .then(res => setFeBaseList(res.data || []))
//       .catch(() => setFeBaseList([]));
//   };


//   const fetchExcessRecords = useCallback((feName) => {
//     if (!feName) { setRows([]); return; }
//     setLoading(true);
//     api.get(`/excess_payment_mgmt/excess-master-list/?fe_name=${encodeURIComponent(feName)}`)
//       .then(res => {
//         setRows(res.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
//           ...item,
//         })));
//       })
//       .catch(() => showError('Failed to load excess records.'))
//       .finally(() => setLoading(false));
//   }, []);


//   useEffect(() => { fetchExcessRecords(selectedFeName); }, [selectedFeName, fetchExcessRecords]);


//   // ── Permission View (eye icon) ────────────────────────────────────────────
//   const handleViewPermissions = (record) => {
//     setPermViewRecord(record);
//     setPermViewUsers([]);
//     setPermViewDialog(true);
//     setPermViewLoading(true);
//     api.get(`/excess_payment_mgmt/excess/bulk-permission/?excess_id=${record.id}`)
//       .then(res => setPermViewUsers(res.data?.users || []))
//       .catch(() => setPermViewUsers(record.auth_user || []))
//       .finally(() => setPermViewLoading(false));
//   };


//   // ── Upload ────────────────────────────────────────────────────────────────
//   const handleFileChange = (e) => { if (e.target.files.length > 0) setSelectedFile(e.target.files[0]); };


//   const handleUploadSubmit = async () => {
//     if (!selectedFile) { showWarning('Please select a file.'); return; }
//     if (!selectedFeId) { showWarning('Please select a Financial Establishment.'); return; }
//     if (!['.xls', '.xlsx'].some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
//       showWarning('Invalid format. Please upload .xls or .xlsx.');
//       return;
//     }
//     const formData = new FormData();
//     formData.append('excel_file', selectedFile);
//     formData.append('fe_id', selectedFeId);
//     try {
//       setUploadingFile(true);
//       await api.post('/excess_payment_mgmt/excess-record-uploader/', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//       });
//       showSuccess('File uploaded successfully.');
//       setOpenUploadDialog(false);
//       const feObj = feBaseList.find(fe => fe.id === selectedFeId);
//       setSelectedFeName(feObj?.name || feObj?.name_of_fe || '');
//       setSelectedFile(null);
//       setSelectedFeId('');
//     } catch (error) {
//       const err = error?.response?.data;
//       if (err?.validation_errors && Array.isArray(err.validation_errors)) {
//         setFullErrorDetails(
//           err.validation_errors.map((e, i) => `Row ${i + 2}: ${e.error || e.message || JSON.stringify(e)}`).join('\n')
//         );
//         setErrorRowCount(err.validation_errors.length);
//         setOpenErrorDialog(true);
//         showError(`Validation failed: ${err.validation_errors.length} rows had errors.`);
//       } else {
//         showError(err?.error || err?.message || 'Failed to upload file.');
//       }
//     } finally {
//       setUploadingFile(false);
//       setUploadProgress(0);
//     }
//   };


//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>


//       {/* ── Header bar ── */}
//       <Box
//         display="flex" justifyContent="space-between" alignItems="center"
//         bgcolor="rgba(195,234,203,0.1)" p={2} flexWrap="wrap" gap={2}
//       >
//         {/* FE Selector — now searchable */}
//         <Box display="flex" gap={2} alignItems="center">
//           <Typography variant="h6" fontWeight="bold">Select FE Base:</Typography>
//           <Autocomplete
//             size="small"
//             sx={{ minWidth: 280 }}
//             options={feBaseList}
//             getOptionLabel={(fe) => fe.name || fe.name_of_fe || String(fe.id) || ''}
//             isOptionEqualToValue={(option, value) => option.id === value.id}
//             value={feBaseList.find(fe => (fe.name || fe.name_of_fe || fe.id) === selectedFeName) || null}
//             onChange={(event, newValue) => {
//               setSelectedFeName(newValue ? (newValue.name || newValue.name_of_fe || newValue.id) : '');
//             }}
//             renderInput={(params) => (
//               <TextField {...params} label="Select FE Base" placeholder="Search FE..." />
//             )}
//           />
//         </Box>


//         {/* Action buttons — visible when FE is selected */}
//         {selectedFeName && (
//           <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
//             <Button
//               variant="contained" color="secondary" size="small"
//               startIcon={<ManageAccountsIcon />}
//               onClick={() => setBulkPermissionDialog(true)}
//               disabled={rows.length === 0}
//             >
//               Bulk Permission
//             </Button>
//             <Button
//               variant="outlined" color="error" size="small"
//               startIcon={<ClearIcon />}
//               onClick={() => setRangeDeleteDialog(true)}
//               disabled={rows.length === 0}
//             >
//               Range Delete
//             </Button>
//             <Button
//               variant="outlined" color="primary" size="small"
//               onClick={() => setOpenUploadDialog(true)}
//             >
//               Upload Excel
//             </Button>
//           </Box>
//         )}
//       </Box>


//       {/* ── Table ── */}
//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : selectedFeName && rows.length > 0 ? (
//         <TableComponent
//           columns={columns}
//           rows={rows}
//           manageColumnStatus
//           enableSort
//           sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//         />
//       ) : selectedFeName ? (
//         <Box p={4} textAlign="center">
//           <Typography>No records found for selected FE.</Typography>
//         </Box>
//       ) : null}


//       {/* ════════════════════════════
//           Dialogs
//       ════════════════════════════ */}


//       {/* ── Creating Record — upload in progress overlay ── */}
//       <Dialog
//         open={uploadingFile}
//         disableEscapeKeyDown
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             px: 4,
//             py: 3,
//             minWidth: 280,
//             textAlign: 'center',
//             boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
//           },
//         }}
//       >
//         <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pb: 1 }}>
//           <CircularProgress size={52} thickness={4.5} />
//           <Typography variant="h6" fontWeight="bold" mt={1}>
//             Creating Records
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Please wait, don't refresh the page…
//           </Typography>
//           <Box sx={{ width: '100%', mt: 1 }}>
//             <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: 2, height: 6 }} />
//             <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
//               {uploadProgress}%
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>


//       {/* Permission View (eye icon) — shows User, SHR, and Forensic Auditor labeled */}
//       <Dialog open={permViewDialog} onClose={() => setPermViewDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           <Typography variant="h6" fontWeight="bold">Allowed Users</Typography>
//           {permViewRecord && (
//             <Typography variant="body2" color="text.secondary">
//               {permViewRecord.reference_id} — {permViewRecord.name}
//             </Typography>
//           )}
//         </DialogTitle>
//         <DialogContent>
//           {permViewLoading ? (
//             <Box display="flex" justifyContent="center" py={3}>
//               <LoadingSpinner size={24} />
//             </Box>
//           ) : permViewUsers.length === 0 ? (
//             <Box py={2} textAlign="center">
//               <Typography variant="body2" color="text.secondary">
//                 No users have been granted permission for this record.
//               </Typography>
//             </Box>
//           ) : (
//             <List dense>
//               {permViewUsers.map((entry, idx) => (
//                 <ListItem
//                   key={entry.id || idx}
//                   divider={idx < permViewUsers.length - 1}
//                   sx={{ alignItems: 'flex-start', py: 1.5 }}
//                 >
//                   <Box display="flex" flexDirection="column" gap={1} width="100%">
//                     {/* Normal User */}
//                     <Box display="flex" alignItems="center" gap={1.5}>
//                       <Avatar sx={{ width: 32, height: 32, fontSize: 13, bgcolor: 'primary.main' }}>
//                         {(entry.name || entry.username || '?')[0].toUpperCase()}
//                       </Avatar>
//                       <Box>
//                         <Typography variant="caption" color="text.secondary" display="block" fontWeight={600}>
//                           USER
//                         </Typography>
//                         <Typography variant="body2" fontWeight={600}>
//                           {entry.name || '—'}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {entry.email || '—'}
//                         </Typography>
//                       </Box>
//                     </Box>

//                     {/* SHR Name */}
//                     <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
//                       <Chip
//                         label="SHR"
//                         size="small"
//                         color="secondary"
//                         variant="outlined"
//                         sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
//                       />
//                       <Typography variant="body2">
//                         {entry.shr_name || '—'}
//                       </Typography>
//                     </Box>

//                     {/* Forensic Auditor */}
//                     <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
//                       <Chip
//                         label="FORENSIC AUDITOR"
//                         size="small"
//                         color="warning"
//                         variant="outlined"
//                         sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
//                       />
//                       <Box>
//                         <Typography variant="body2">
//                           {entry.forensic_auditor_name || '—'}
//                         </Typography>
//                         {entry.forensic_auditor_email && (
//                           <Typography variant="caption" color="text.secondary">
//                             {entry.forensic_auditor_email}
//                           </Typography>
//                         )}
//                       </Box>
//                     </Box>

//                     {entry.authorized_date && (
//                       <Typography variant="caption" color="text.disabled" pl={0.5}>
//                         Authorized on {new Date(entry.authorized_date).toLocaleString()}
//                       </Typography>
//                     )}
//                   </Box>
//                 </ListItem>
//               ))}
//             </List>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setPermViewDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>


//       {/* Range Delete — using separate component */}
//       <AdminExcessRangeDeleteDialog
//         open={rangeDeleteDialog}
//         onClose={() => setRangeDeleteDialog(false)}
//         feName={selectedFeName}
//         feId={selectedFeId}
//         rows={rows}
//         onSuccess={showSuccess}
//         onError={showError}
//         onDone={() => fetchExcessRecords(selectedFeName)}
//       />


//       {/* Bulk Permission */}
//       <BulkPermissionDialog
//         open={bulkPermissionDialog}
//         onClose={() => {
//           setBulkPermissionDialog(false);
//           fetchExcessRecords(selectedFeName); // refresh to update permission counts
//         }}
//         rows={rows}
//         onSuccess={showSuccess}
//         onError={showError}
//       />


//       {/* Upload Excel */}
//       <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Upload Excess Amount Excel File</DialogTitle>
//         <DialogContent>
//           <Box display="flex" gap={1} alignItems="center" mb={2} mt={1}>
//             <TextField select fullWidth size="small" label="Financial Establishment (FE Base)"
//               value={selectedFeId} onChange={e => setSelectedFeId(e.target.value)} disabled={uploadingFile}>
//               {feBaseList.map(fe => (
//                 <MenuItem key={fe.id} value={fe.id}>{fe.name || fe.name_of_fe || fe.id}</MenuItem>
//               ))}
//             </TextField>
//             <Tooltip title="View Sample Format">
//               <IconButton size="small" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
//                 <ContentPasteIcon />
//               </IconButton>
//             </Tooltip>
//           </Box>
//           <Button variant="outlined" component="label" fullWidth>
//             {selectedFile ? selectedFile.name : 'Select Excel File (.xls, .xlsx)'}
//             <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
//           </Button>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
//           <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile || !selectedFeId || !selectedFile}>
//             Upload
//           </Button>
//         </DialogActions>
//       </Dialog>


//       {/* Sample Format */}
//       <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Excel Column Headers (Exact Match Required)</DialogTitle>
//         <DialogContent dividers>
//           <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '14px' }}>
//             {sampleHeaders.join('\n')}
//           </Typography>
//           <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
//             * Required: reference_id, name, account_number, ifsc_code, deposited_amount, returned_amount, excess_amount
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>


//       {/* Validation Errors */}
//       <Dialog
//         open={openErrorDialog}
//         onClose={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
//         maxWidth="md" fullWidth
//       >
//         <DialogTitle>Validation Errors ({errorRowCount} rows failed)</DialogTitle>
//         <DialogContent sx={{ maxHeight: 400, overflow: 'auto' }}>
//           <Typography component="pre" sx={{
//             whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px',
//             backgroundColor: '#f5f5f5', p: 2, borderRadius: 1,
//           }}>
//             {fullErrorDetails}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
//             variant="contained" color="primary"
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>


//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={() => setSnackbarOpen(false)}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  MenuItem,
  Chip,
  Autocomplete,
  IconButton,
  Tooltip,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import {
  Clear as ClearIcon,
  ContentPaste as ContentPasteIcon,
  ManageAccounts as ManageAccountsIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import PeopleIcon from '@mui/icons-material/People';
import api from '../../../api/axiosInterceptor';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { BulkPermissionDialog } from './adminEpmsPermission';
import { AdminExcessRangeDeleteDialog } from './adminEpmsBulkDelete';


const sampleHeaders = [
  "reference_id", "name", "address", "contact_number",
  "nominee_name", "nominee_address", "nominee_contact_number",
  "account_number", "ifsc_code", "catogary",
  "deposited_amount", "returned_amount", "excess_amount","pan_no",
];


export const AdminExcessMasterComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [feBaseList, setFeBaseList] = useState([]);
  const [selectedFeName, setSelectedFeName] = useState('');
  const [selectedFeId, setSelectedFeId] = useState('');


  // Range delete dialog
  const [rangeDeleteDialog, setRangeDeleteDialog] = useState(false);


  // Bulk permission dialog
  const [bulkPermissionDialog, setBulkPermissionDialog] = useState(false);


  // Permission view dialog (eye icon)
  const [permViewDialog, setPermViewDialog] = useState(false);
  const [permViewRecord, setPermViewRecord] = useState(null);
  const [permViewUsers, setPermViewUsers] = useState([]);
  const [permViewLoading, setPermViewLoading] = useState(false);


  // Upload
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);


  // Sample / Error dialogs
  const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [fullErrorDetails, setFullErrorDetails] = useState('');
  const [errorRowCount, setErrorRowCount] = useState(0);


  // Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');


  const showSuccess = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('success'); setSnackbarOpen(true); };
  const showError   = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('error');   setSnackbarOpen(true); };
  const showWarning = (msg) => { setSnackbarMessage(msg); setSnackbarSeverity('warning'); setSnackbarOpen(true); };


  // ── Columns — with Permissions column at the end ─────────────────────────
  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'reference_id', field: 'reference_id', headerName: 'Reference ID', width: 150 },
    { id: 'name', field: 'name', headerName: 'Name', width: 150 },
    { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
    { id: 'address', field: 'address', headerName: 'Address', width: 200 },
    { id: 'contact_number', field: 'contact_number', headerName: 'Contact', width: 130 },
    { id: 'account_number', field: 'account_number', headerName: 'Account No', width: 150 },
    { id: 'ifsc_code', field: 'ifsc_code', headerName: 'IFSC Code', width: 120 },
    { id: 'catogary', field: 'catogary', headerName: 'Category', width: 120 },
    { id: 'deposited_amount', field: 'deposited_amount', headerName: 'Deposited', width: 130 },
    { id: 'returned_amount', field: 'returned_amount', headerName: 'Returned', width: 130 },
    { id: 'excess_amount', field: 'excess_amount', headerName: 'Excess Amount', width: 130 },
    {
      id: 'permissions',
      field: 'permissions',
      headerName: 'Permissions',
      width: 120,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" gap={0.5}>
            <Tooltip title="View allowed users">
              <IconButton size="small" onClick={() => handleViewPermissions(params.row)}>
                <PeopleIcon  fontSize="small" color="action" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];


  // ── Data fetching ─────────────────────────────────────────────────────────
  useEffect(() => { fetchFeBaseList(); }, []);


  const fetchFeBaseList = () => {
    api.get('/fe-mgmt/fe-base/')
      .then(res => setFeBaseList(res.data || []))
      .catch(() => setFeBaseList([]));
  };


  const fetchExcessRecords = useCallback((feName) => {
    if (!feName) { setRows([]); return; }
    setLoading(true);
    api.get(`/excess_payment_mgmt/excess-master-list/?fe_name=${encodeURIComponent(feName)}`)
      .then(res => {
        setRows(res.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
          ...item,
        })));
      })
      .catch(() => showError('Failed to load excess records.'))
      .finally(() => setLoading(false));
  }, []);


  useEffect(() => { fetchExcessRecords(selectedFeName); }, [selectedFeName, fetchExcessRecords]);


  // ── Permission View (eye icon) ────────────────────────────────────────────
  const handleViewPermissions = (record) => {
    setPermViewRecord(record);
    setPermViewUsers([]);
    setPermViewDialog(true);
    setPermViewLoading(true);
    api.get(`/excess_payment_mgmt/excess/bulk-permission/?excess_id=${record.id}`)
      .then(res => setPermViewUsers(res.data?.users || []))
      .catch(() => setPermViewUsers(record.auth_user || []))
      .finally(() => setPermViewLoading(false));
  };


  // ── Upload ────────────────────────────────────────────────────────────────
  const handleFileChange = (e) => { if (e.target.files.length > 0) setSelectedFile(e.target.files[0]); };


  const handleUploadSubmit = async () => {
    if (!selectedFile) { showWarning('Please select a file.'); return; }
    if (!selectedFeId) { showWarning('Please select a Financial Establishment.'); return; }
    if (!['.xls', '.xlsx'].some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
      showWarning('Invalid format. Please upload .xls or .xlsx.');
      return;
    }
    const formData = new FormData();
    formData.append('excel_file', selectedFile);
    formData.append('fe_id', selectedFeId);
    try {
      setUploadingFile(true);
      await api.post('/excess_payment_mgmt/excess-record-uploader/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
      });
      showSuccess('File uploaded successfully.');
      setOpenUploadDialog(false);
      const feObj = feBaseList.find(fe => fe.id === selectedFeId);
      setSelectedFeName(feObj?.name || feObj?.name_of_fe || '');
      setSelectedFile(null);
      setSelectedFeId('');
    } catch (error) {
      const err = error?.response?.data;
      if (err?.validation_errors && Array.isArray(err.validation_errors)) {
        setFullErrorDetails(
          err.validation_errors.map((e, i) => `Row ${i + 2}: ${e.error || e.message || JSON.stringify(e)}`).join('\n')
        );
        setErrorRowCount(err.validation_errors.length);
        setOpenErrorDialog(true);
        showError(`Validation failed: ${err.validation_errors.length} rows had errors.`);
      } else {
        showError(err?.error || err?.message || 'Failed to upload file.');
      }
    } finally {
      setUploadingFile(false);
      setUploadProgress(0);
    }
  };


  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>


      {/* ── Header bar ── */}
      <Box
        display="flex" justifyContent="space-between" alignItems="center"
        bgcolor="rgba(195,234,203,0.1)" p={2} flexWrap="wrap" gap={2}
      >
        {/* FE Selector — now searchable */}
        <Box display="flex" gap={2} alignItems="center">
          <Typography variant="h6" fontWeight="bold">Select FE Base:</Typography>
          <Autocomplete
            size="small"
            sx={{ minWidth: 280 }}
            options={feBaseList}
            getOptionLabel={(fe) => fe.name || fe.name_of_fe || String(fe.id) || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={feBaseList.find(fe => (fe.name || fe.name_of_fe || fe.id) === selectedFeName) || null}
            onChange={(event, newValue) => {
              setSelectedFeName(newValue ? (newValue.name || newValue.name_of_fe || newValue.id) : '');
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select FE Base" placeholder="Search FE..." />
            )}
          />
        </Box>


        {/* Action buttons — visible when FE is selected */}
        {selectedFeName && (
          <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
            <Button
              variant="contained" color="secondary" size="small"
              startIcon={<ManageAccountsIcon />}
              onClick={() => setBulkPermissionDialog(true)}
              disabled={rows.length === 0}
            >
              Bulk Permission
            </Button>
            <Button
              variant="outlined" color="error" size="small"
              startIcon={<ClearIcon />}
              onClick={() => setRangeDeleteDialog(true)}
              disabled={rows.length === 0}
            >
              Range Delete
            </Button>
            <Button
              variant="outlined" color="primary" size="small"
              onClick={() => setOpenUploadDialog(true)}
            >
              Upload Excel
            </Button>
          </Box>
        )}
      </Box>


      {/* ── Table ── */}
      {loading ? (
        <LoadingSpinner size={30} />
      ) : selectedFeName && rows.length > 0 ? (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
        />
      ) : selectedFeName ? (
        <Box p={4} textAlign="center">
          <Typography>No records found for selected FE.</Typography>
        </Box>
      ) : null}


      {/* ════════════════════════════
          Dialogs
      ════════════════════════════ */}


      {/* ── Creating Record — upload in progress overlay ── */}
      <Dialog
        open={uploadingFile}
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 3,
            px: 4,
            py: 3,
            minWidth: 280,
            textAlign: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          },
        }}
      >
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pb: 1 }}>
          <CircularProgress size={52} thickness={4.5} />
          <Typography variant="h6" fontWeight="bold" mt={1}>
            Creating Records
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait, don't refresh the page…
          </Typography>
          <Box sx={{ width: '100%', mt: 1 }}>
            <LinearProgress variant="determinate" value={uploadProgress} sx={{ borderRadius: 2, height: 6 }} />
            <Typography variant="caption" color="text.secondary" mt={0.5} display="block">
              {uploadProgress}%
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>


      {/* Permission View (eye icon) — shows User, SHR, and Forensic Auditor labeled */}
      <Dialog open={permViewDialog} onClose={() => setPermViewDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">Allowed Users</Typography>
          {permViewRecord && (
            <Typography variant="body2" color="text.secondary">
              {permViewRecord.reference_id} — {permViewRecord.name}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent>
          {permViewLoading ? (
            <Box display="flex" justifyContent="center" py={3}>
              <LoadingSpinner size={24} />
            </Box>
          ) : permViewUsers.length === 0 ? (
            <Box py={2} textAlign="center">
              <Typography variant="body2" color="text.secondary">
                No users have been granted permission for this record.
              </Typography>
            </Box>
          ) : (
            <List dense>
              {permViewUsers.map((entry, idx) => (
                <ListItem
                  key={entry.id || idx}
                  divider={idx < permViewUsers.length - 1}
                  sx={{ alignItems: 'flex-start', py: 1.5 }}
                >
                  <Box display="flex" flexDirection="column" gap={1} width="100%">
                    {/* Normal User */}
                    <Box display="flex" alignItems="center" gap={1.5}>
                      <Avatar sx={{ width: 32, height: 32, fontSize: 13, bgcolor: 'primary.main' }}>
                        {(entry.name || entry.username || '?')[0].toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography variant="caption" color="text.secondary" display="block" fontWeight={600}>
                          USER
                        </Typography>
                        <Typography variant="body2" fontWeight={600}>
                          {entry.name || '—'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {entry.email || '—'}
                        </Typography>
                      </Box>
                    </Box>

                    {/* SHR Name */}
                    <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
                      <Chip
                        label="SHR"
                        size="small"
                        color="secondary"
                        variant="outlined"
                        sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
                      />
                      <Typography variant="body2">
                        {entry.shr_name || '—'}
                      </Typography>
                    </Box>

                    {/* Forensic Auditor */}
                    <Box display="flex" alignItems="center" gap={1.5} pl={0.5}>
                      <Chip
                        label="FORENSIC AUDITOR"
                        size="small"
                        color="warning"
                        variant="outlined"
                        sx={{ height: 20, fontSize: 10, fontWeight: 700 }}
                      />
                      <Box>
                        <Typography variant="body2">
                          {entry.forensic_auditor_name || '—'}
                        </Typography>
                        {entry.forensic_auditor_email && (
                          <Typography variant="caption" color="text.secondary">
                            {entry.forensic_auditor_email}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    {entry.authorized_date && (
                      <Typography variant="caption" color="text.disabled" pl={0.5}>
                        Authorized on {new Date(entry.authorized_date).toLocaleString()}
                      </Typography>
                    )}
                  </Box>
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPermViewDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* Range Delete — using separate component */}
      <AdminExcessRangeDeleteDialog
        open={rangeDeleteDialog}
        onClose={() => setRangeDeleteDialog(false)}
        feName={selectedFeName}
        feId={selectedFeId}
        rows={rows}
        onSuccess={showSuccess}
        onError={showError}
        onDone={() => fetchExcessRecords(selectedFeName)}
      />


      {/* Bulk Permission */}
      <BulkPermissionDialog
        open={bulkPermissionDialog}
        onClose={() => {
          setBulkPermissionDialog(false);
          fetchExcessRecords(selectedFeName);
        }}
        rows={rows}
        onSuccess={showSuccess}
        onError={showError}
      />


      {/* Upload Excel */}
      <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Upload Excess Amount Excel File</DialogTitle>
        <DialogContent>
          {/* ── CHANGED: TextField select → Autocomplete ── */}
          <Box display="flex" gap={1} alignItems="center" mb={2} mt={1}>
            <Autocomplete
              fullWidth
              size="small"
              options={feBaseList}
              getOptionLabel={(fe) => fe.name || fe.name_of_fe || String(fe.id) || ''}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={feBaseList.find(fe => fe.id === selectedFeId) || null}
              onChange={(event, newValue) => setSelectedFeId(newValue ? newValue.id : '')}
              disabled={uploadingFile}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Financial Establishment (FE Base)"
                  placeholder="Search FE..."
                />
              )}
            />
            <Tooltip title="View Sample Format">
              <IconButton size="small" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
                <ContentPasteIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Button variant="outlined" component="label" fullWidth>
            {selectedFile ? selectedFile.name : 'Select Excel File (.xls, .xlsx)'}
            <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
          <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile || !selectedFeId || !selectedFile}>
            Upload
          </Button>
        </DialogActions>
      </Dialog>


      {/* Sample Format */}
      <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Excel Column Headers (Exact Match Required)</DialogTitle>
        <DialogContent dividers>
          <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '14px' }}>
            {sampleHeaders.join('\n')}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            * Required: reference_id, name, account_number, ifsc_code, deposited_amount, returned_amount, excess_amount
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      {/* Validation Errors */}
      <Dialog
        open={openErrorDialog}
        onClose={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
        maxWidth="md" fullWidth
      >
        <DialogTitle>Validation Errors ({errorRowCount} rows failed)</DialogTitle>
        <DialogContent sx={{ maxHeight: 400, overflow: 'auto' }}>
          <Typography component="pre" sx={{
            whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '13px',
            backgroundColor: '#f5f5f5', p: 2, borderRadius: 1,
          }}>
            {fullErrorDetails}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => { setOpenErrorDialog(false); setFullErrorDetails(''); setErrorRowCount(0); }}
            variant="contained" color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};